import {SafeHtml} from '@angular/platform-browser';

export interface FaqEntry {
  title: string;
  questionSet: QuestionEntry[];
  styles?: any;
  classes?: any;
}

export interface QuestionEntry {
  title: string;
  subtitles: SubtitleEntryImpl[];
}

interface SubtitleEntry {
  subtitle: string;
  content: string;
  classSwitch?: boolean;
}

export class SubtitleEntryImpl implements SubtitleEntry {
  subtitle: string;
  content: string;
  classSwitch = false;

  constructor(subtitle: string, content: string) {
    this.subtitle = subtitle;
    this.content = content;
  }
}
